<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "ManageFrequentlyAskQuestions",
  data: () => ({
    FrequentQuestion: '',
    FrequentAnswer: '',
  }),
  props: {
    programId: {
      required: true
    }
  }
})
</script>

<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12"   >
            <div>
              <ValidationProvider name="FrequentQuestion" rules="required" v-slot="{ errors }" >
                <v-text-field
                    label="Frequent Question"
                    :error-messages="errors"
                    solo
                    v-model="FrequentQuestion"
                ></v-text-field>
              </ValidationProvider>
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12"   >
            <div style="margin-top: -30px">
              <ValidationProvider name="FrequentAnswer" rules="required" v-slot="{ errors }" >
                <v-text-field
                    label="Frequent Answer"
                    :error-messages="errors"
                    solo
                    v-model="FrequentAnswer"
                ></v-text-field>
              </ValidationProvider>
            </div>
          </v-col>

        </v-row>
        <div class="pa-3">
          <div class="text-right">
            <v-btn color="primary">Update</v-btn>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <br><hr style="border-top: 1px solid #ddd">
    <br>
    <div>

    </div>

  </div>
</template>

<style scoped>

</style>
